import { IProjectModuleWellConnectSurfaceEquipment } from '../../interfaces/iproject-module-well-connect-surface-equipment';
import { Project } from '../project';

export class ProjectModuleWellConnectSurfaceEquipmentBase {
  ProjectModuleWellConnectSurfaceEquipmentId: number;
  ProjectId: number;
  Description: string;
  BulkSeparatorNewness: string | null;
  BulkSeparatorDiameter: string | null;
  TestAllocationOfAllWells: boolean | null;
  QuantityOfPermanentSeparators: number | null;
  QuantityOfRentalSeparators: number | null;
  IsPower: boolean | null;
  PowerLineLength: number | null;
  IsScada: boolean | null;
  IsWellHeadConnect: boolean | null;
  InletHeadertoWellLength: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  UseExistingBulkSeparator: boolean | null;
  Risked: boolean | null;
  TotalOil: number | null;
  TotalGas: number | null;
  TotalWater: number | null;
  GORSC: number | null;
  WellCount: number | null;

  Project?: Project;

  constructor(item?: IProjectModuleWellConnectSurfaceEquipment) {
    if (item) {

      this.ProjectModuleWellConnectSurfaceEquipmentId = item.ProjectModuleWellConnectSurfaceEquipmentId;
      this.ProjectId = item.ProjectId;
      this.Description = item.Description;
      this.BulkSeparatorNewness = item.BulkSeparatorNewness;
      this.BulkSeparatorDiameter = item.BulkSeparatorDiameter;
      this.TestAllocationOfAllWells = item.TestAllocationOfAllWells;
      this.QuantityOfPermanentSeparators = item.QuantityOfPermanentSeparators;
      this.QuantityOfRentalSeparators = item.QuantityOfRentalSeparators;
      this.IsPower = item.IsPower;
      this.PowerLineLength = item.PowerLineLength;
      this.IsScada = item.IsScada;
      this.IsWellHeadConnect = item.IsWellHeadConnect;
      this.InletHeadertoWellLength = item.InletHeadertoWellLength;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.UseExistingBulkSeparator = item.UseExistingBulkSeparator;
      this.Risked = item.Risked;
      this.TotalOil = item.TotalOil;
      this.TotalGas = item.TotalGas;
      this.TotalWater = item.TotalWater;
      this.GORSC = item.GORSC;
      this.WellCount = item.WellCount;

      this.Project = new Project(item.Project);
    }
  }
}